import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const addressAutocomplete: AnswerPathTreeNode = {
  path: 'addressAutocomplete',
  nodeId: NodeIds.insuredAddressAutocomplete,
};
